
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[cName]/product/[productId]",
      function () {
        return require("private-next-pages/stores/[cName]/product/[productId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[cName]/product/[productId]"])
      });
    }
  